import React, { useState, useMemo } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { TextField, Box, Typography } from '@mui/material';

// Real API data with joinedTimestamp
const mockAccounts = [
  {
    id: "533267113898",
    name: "AccountPipelineD (Demo)",
    email: "accountcreationpipeline-d.cloud@verisk.com",
    status: "ACTIVE",
    joinedMethod: "CREATED",
    joinedTimestamp: "2024-02-13T05:02:20.579000+00:00",
    tags: { functionalUnit: "EES", businessUnit: "ModelEx", accountOwner: "Ripul Handa" }
  },
  {
    id: "975050185290", 
    name: "Account Creation Pipeline-A (Demo)",
    email: "accountcreationpipeline-a.cloud@verisk.com",
    status: "ACTIVE",
    joinedMethod: "CREATED", 
    joinedTimestamp: "2024-01-22T18:10:43.973000+00:00",
    tags: { functionalUnit: "EES", businessUnit: "AIR", accountOwner: "Ripul Handa" }
  },
  {
    id: "617095680186",
    name: "Verisk Child2 (Sandbox)",
    email: "veriskchild2.cloud@verisk.com",
    status: "ACTIVE",
    joinedMethod: "CREATED",
    joinedTimestamp: "2019-10-10T19:20:04.342000+00:00",
    tags: { functionalUnit: "IST", businessUnit: "VDAS", accountOwner: "Philip Galea" }
  }
];

function TestApp() {
  const [functionalUnitFilter, setFunctionalUnitFilter] = useState('');

  // Filter accounts based on functional unit
  const filteredAccounts = useMemo(() => {
    if (!functionalUnitFilter || functionalUnitFilter.trim() === '') {
      return mockAccounts;
    }
    
    return mockAccounts.filter(account => {
      const accountFunctionalUnit = account.tags?.functionalUnit || '';
      return accountFunctionalUnit.toLowerCase().includes(functionalUnitFilter.toLowerCase());
    });
  }, [functionalUnitFilter]);

  const columns = useMemo(() => {
    const baseColumns = [
      { field: 'name', headerName: 'Account Name', width: 200 },
      { field: 'id', headerName: 'Account ID', width: 130 },
      { field: 'status', headerName: 'Status', width: 100 },
      { field: 'joinedMethod', headerName: 'Joined Method', width: 130 },
      { 
        field: 'joinedTimestamp', 
        headerName: 'Joined Date', 
        width: 150,
        renderCell: (params) => {
          try {
            if (!params.value || params.value === '') return <span>-</span>;
            const date = new Date(params.value);
            if (isNaN(date.getTime())) return <span>Invalid Date</span>;
            return <span>{date.toLocaleDateString()}</span>;
          } catch (error) {
            console.warn('Error formatting date:', error, params.value);
            return <span>Error</span>;
          }
        }
      }
    ];

    const shouldShowBusinessUnit = functionalUnitFilter && functionalUnitFilter.trim() !== '';
    console.log('functionalUnitFilter:', functionalUnitFilter, 'shouldShowBusinessUnit:', shouldShowBusinessUnit);
    
    if (shouldShowBusinessUnit) {
      baseColumns.push({
        field: 'businessUnit',
        headerName: 'Business Unit',
        width: 180,
        renderCell: (params) => {
          try {
            const businessUnit = params.row?.tags?.businessUnit || 'N/A';
            return <span>{businessUnit}</span>;
          } catch (error) {
            console.error('Error accessing business unit:', error);
            return <span>Error</span>;
          }
        }
      });
    }

    return baseColumns;
  }, [functionalUnitFilter]);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>Test Business Unit Column</Typography>
      
      <TextField
        label="Functional Unit Filter"
        value={functionalUnitFilter}
        onChange={(e) => setFunctionalUnitFilter(e.target.value)}
        placeholder="Type EES or IST"
        sx={{ mb: 2, width: 300 }}
      />
      
      <Typography variant="body2" sx={{ mb: 2 }}>
        Showing {filteredAccounts.length} of {mockAccounts.length} accounts
        {functionalUnitFilter && ` (filtered by: ${functionalUnitFilter})`}
      </Typography>
      
      <Box sx={{ height: 400, width: '100%' }}>
        <DataGrid
          rows={filteredAccounts}
          columns={columns}
          pageSize={10}
        />
      </Box>
    </Box>
  );
}

export default TestApp;